<div #top></div>
@if (!captured && !useCamera) {
  <div class="d-none d-lg-block" style="height: 25vh;" ></div>
}
<div class="d-flex justify-content-center align-items-center">

  <div  class="main">
    <div>

      <div class="card shadow mt-0 text-center rounded-3">
        <!--          <div style="height: 85vh;">-->
        @if (!video_or_image) {
          <div class="card-header rounded-top-3 px-0 py-0">
            <ul class="nav justify-content-center small" >
              @if (show1) {
                <li
                  class="nav-item "
                >
                  <a
                    class="nav-link text-dark"
                    [class.fw-bold]="selectedOption === 'summarize'"
                    [class.text-primary]="selectedOption === 'summarize'"
                    [class.text-dark]="selectedOption !== 'summarize'"
                    href="#"
                    (click)="onSelect('summarize'); $event.preventDefault()"
                  >
                    {{ 'SUMMARIZE' | translate }}
                  </a>
                </li>
              }
              @if (show2) {
                <li
                  class="nav-item"
                >
                  <a
                    class="nav-link text-dark"
                    [class.fw-bold]="selectedOption === 'explain'"
                    [class.text-primary]="selectedOption === 'explain'"
                    [class.text-dark]="selectedOption !== 'explain'"
                    href="#"
                    (click)="onSelect('explain'); $event.preventDefault()"
                  >
                    {{ 'EXPLAIN' | translate }}
                  </a>
                </li>
              }
              @if (show3) {
                <li
                  class="nav-item"
                >
                  <a
                    class="nav-link text-dark"
                    [class.fw-bold]="selectedOption === 'paraphrase'"
                    [class.text-primary]="selectedOption === 'paraphrase'"
                    [class.text-dark]="selectedOption !== 'paraphrase'"
                    href="#"
                    (click)="onSelect('paraphrase'); $event.preventDefault()"
                  >
                    {{ 'PARAPHRASE' | translate }}
                  </a>
                </li>
              }
              @if (show3) {
                <li
                  class="nav-item"
                >
                  <a
                    class="nav-link"
                    [class.fw-bold]="selectedOption === 'simplify'"
                    [class.text-primary]="selectedOption === 'simplify'"
                    [class.text-dark]="selectedOption !== 'simplify'"
                    href="#"
                    (click)="onSelect('simplify'); $event.preventDefault()"
                  >
                    {{ 'SIMPLIFY' | translate }}
                  </a>
                </li>
              }

            </ul>
          </div>
        }

        @if (video_or_image) {

          <div class="card-body p-0 rounded-top-3">
            <video #video autoplay playsinline [hidden]="captured || !started" class="w-100 rounded-top-3" style="display: block; margin: 0 auto;"> </video>  <!-- w-100 and h-auto for responsiveness -->
            <canvas #canvas style="display: none;" class="w-100 rounded-top-3" [hidden]="!started"></canvas>
            <img [hidden]="!photo || !started" [src]="photo" alt="Captured photo" class="w-100 rounded-top-3" >

          </div>
        }


        <div class="card-body">
          @if (selectedOption === 'summarize') {
            <div class="card-title mb-5 text-center text-dark fs-2 mt-5" [hidden]="captured || useCamera">{{ 'MAIN_QUESTION' | translate }}</div>
          }
          @if (selectedOption === 'explain') {
            <div class="card-title mb-5 text-center text-dark fs-2 mt-5" [hidden]="captured || useCamera">{{ 'MAIN_QUESTION_2' | translate }}</div>
          }
          @if (selectedOption === 'paraphrase') {
            <div class="card-title mb-5 text-center text-dark fs-2 mt-5" [hidden]="captured || useCamera">{{ 'MAIN_QUESTION_3' | translate }}</div>
          }
          @if (selectedOption === 'simplify') {
            <div class="card-title mb-5 text-center text-dark fs-2 mt-5" [hidden]="captured || useCamera">{{ 'MAIN_QUESTION_4' | translate }}</div>
          }

          <div class="d-md-flex d-flex-col justify-content-center gap-2 mt-1">
            <input
              type="file"
              id="upload-photo"
              accept="image/*"
              (change)="uploadPhoto($event)"
              hidden
            />

            @if (!captured && !useCamera) {
              <label
                for="upload-photo"
                class="btn btn-outline-secondary no-underline rounded-5 m-0 px-3 px-sm-5 w-md-100 mb-3"
              >
                📁 {{ 'UPLOAD_PHOTO' | translate }}
              </label>
            }

            @if (hasCamera && !captured && !useCamera) {
              <button
                (click)="initCamera()"
                class="btn btn-primary m-0 rounded-5 px-3 px-sm-5  w-md-100 mb-3"
              >
                📸 {{ 'USE_CAMERA' | translate }}
              </button>
            }
          </div>

          <div [hidden]="captured || !useCamera">
            <button (click)="capture()" [hidden]="captured || !useCamera" class="btn btn-primary rounded-5 w-md-100 px-5" >📸 {{ 'TAKE_PHOTO' | translate }}</button>
          </div>
          <div class="d-md-flex d-flex-col justify-content-center gap-2 mt-1">
            <!--          <button (click)="retry()" [hidden]="!captured || prompted" class="btn btn-outline-secondary no-underline rounded-5 m-0 px-3 px-sm-5 w-md-100 mb-3">🔁 {{ 'RETRY' | translate }}</button>-->
            @if (selectedOption === 'summarize') {
              <button (click)="upload()" [hidden]="!captured || prompted" class="btn btn-primary m-0 rounded-5 px-3 px-sm-5  w-md-100 mb-3" >✨ {{ 'SUMMARIZE' | translate }}</button>
            }
            @if (selectedOption === 'explain') {
              <button (click)="upload()" [hidden]="!captured || prompted" class="btn btn-primary m-0 rounded-5 px-3 px-sm-5  w-md-100 mb-3" >✨ {{ 'EXPLAIN' | translate }}</button>
            }
            @if (selectedOption === 'paraphrase') {
              <button (click)="upload()" [hidden]="!captured || prompted" class="btn btn-primary m-0 rounded-5 px-3 px-sm-5  w-md-100 mb-3" >✨ {{ 'PARAPHRASE' | translate }}</button>
            }
            @if (selectedOption === 'simplify') {
              <button (click)="upload()" [hidden]="!captured || prompted" class="btn btn-primary m-0 rounded-5 px-3 px-sm-5  w-md-100 mb-3" >✨ {{ 'SIMPLIFY' | translate }}</button>
            }
            <div [hidden]="!prompted || completed" class="spinner-grow small text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>


      <!-- Text block -->
      <div class="pt-3" [hidden]="photoSlotsCount < 1">
        <!--    6 images next to each other -->
        <div class="card shadow mt-2 text-center rounded-3 mb-3">

          <div class="card-header rounded-top-3">

            <ul class="nav nav-pills card-header-pills justify-content-center">
              <li class="nav-item" style="visibility: hidden;">
                <span class="nav-link">a</span>
              </li>
              @if (!(!captured || prompted || hideMultiImageButtons)) {
                <li class="nav-item">
                  <input
                    type="file"
                    id="upload-another-photo"
                    accept="image/*"
                    (change)="uploadPhoto($event)"
                    hidden
                  />
                  <label
                    for="upload-photo"
                    class="btn nav-link"
                  >
                    ➕ 📁
                  </label>
                </li>
                @if (hasCamera && !(!captured || prompted || hideMultiImageButtons)) {
                  <li class="nav-item" >
                    <button
                      (click)="initCamera()"
                      class="btn nav-link"
                    >
                      ➕ 📸
                    </button>

                  </li>
                }
              }
              <li class="nav-item" style="visibility: hidden;">
                <span class="nav-link">a</span>
              </li>
            </ul>
          </div>

          @if (photoSlots[0] != null) {
            <div class="image-grid" >
              @for (photo of photoSlots; track $index) {
                @if (photo) {
                  <!--                <div class="image">-->
                  <img [src]="photo" [alt]="'Photo ' + ($index + 1)" class="image img-fluid object-fit-cover p-0" />
                  <!--                </div>-->
                }
              }
            </div>
          }
          <div class="card-body text-start">
            <div class="text-muted mb-0 pb-1 px-1" [hidden]="!prompted">
            </div>
            <div #scrollContainer class="scroll-container">
              <markdown [data]="output" [hidden]="!prompted"></markdown>
              <div #bottom style="height: 30px; overflow-y: auto;" [hidden]="!prompted"></div>
            </div>
            <div class="d-md-flex d-flex-col justify-content-center gap-2 mt-3">
              <button (click)="retry()" [hidden]="!captured || prompted" class="btn btn-outline-secondary no-underline rounded-5 m-0 px-3 px-sm-5 w-md-100 mb-3">🔁 {{ 'RETRY' | translate }}</button>
              <button (click)="retry()" [hidden]="!completed" class="btn btn-outline-secondary no-underline rounded-5 m-0 px-3 px-sm-5 w-md-100 mb-3">🔁 {{ 'RETRY' | translate }}</button>
            </div>
          </div>
        </div>
        <!--        </div>-->

      </div>
    </div>
  </div>

</div>

@if (!captured && !useCamera) {
  <div style="height: 25vh;" ></div>
}
@if (!(captured || !useCamera)) {
  <div class="d-block d-lg-none" style="height: 10vh;" ></div>
}

<div [hidden]="prompted">
  <app-summarizer-info></app-summarizer-info>
</div>
